import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TestInstructionDialogComponent } from 'projects/selflearnv2-ui/src/app/modules/feature/self-learn-v2/components/test-instruction-dialog/test-instruction-dialog.component';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-practice-card',
  templateUrl: './practice-card.component.html',
  styleUrls: ['./practice-card.component.css']
})
export class PracticeCardComponent implements OnInit {

  @Input() parcticeCardData:any;

  constructor(public dialog: MatDialog, 
    public selfLearnService: SelfLearnService, public router: Router,
    public dialogRef: MatDialogRef<TestInstructionDialogComponent>) { }

  ngOnInit(): void {
  }

  startTest(topicData:any) {
    localStorage.setItem('subtopicCount', topicData.subtopicCount);
    localStorage.setItem('selfLearnSelectedTopicId', topicData.topicId);
    localStorage.setItem("selfLearnSelectedTopicName", topicData.topicName);
    localStorage.setItem('currentLevel', topicData.levelsInProgress);
    if(topicData.levelsCompleted == 4){this.router.navigate([`selfLearn-V2/practice-completion`]);}
    else{this.router.navigate([`selfLearn-V2/practice-questions`]);}
    // this.dialog.open(TestInstructionDialogComponent, { width:'768px', panelClass: 'test-instruction-modal' });
    // this.dialogRef.close(true);
    // this.dialog.open(StartTestDialogComponent, { width: '768px', panelClass: ['start-test-modal', 'mweb-stiky-bottom'] });
  }

  getActionDisplayName(level:any){
    return (level == 0 || level == undefined || null) ? 'Practice now' : 'Resume now';
  }

}
